export const heroStats = [
  { icon: 'ri-fire-line', label: '每日更新', value: '50+部' },
  { icon: 'ri-4k-line', label: '超清画质', value: '1080P' },
  { icon: 'ri-vip-crown-line', label: '完全免费', value: '0元观影' },
];

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '观影优势', href: '#features' },
  { label: '关于七七', href: '#about' },
  { label: '精选专题', href: '#index' },
  { label: '常见问题', href: '#faq' },
  { label: '观众热评', href: '#comments' },
];

export const appEntry = {
  title: '随时随地，畅爽观影',
  subtitle: '手机、平板、电脑全平台支持，打开浏览器即点即看，无需下载任何App',
  features: ['HTML5播放器', '自适应码率', '省流模式', '投屏支持'],
};

export const aboutContent = {
  title: '关于七七影院',
  intro: '七七影院成立于2020年，是国内领先的免费高清影视在线观看平台。我们致力于为广大影迷提供最便捷、最流畅的在线观影体验，无需注册、无需付费、无需等待，打开网页即可畅享海量影视资源。',
  detail: '平台汇聚了超过10万部国内外电影、电视剧、综艺和动漫资源，涵盖动作、喜剧、爱情、科幻、悬疑、恐怖、战争、纪录片等全品类内容。每日由专业编辑团队精选更新，确保您不错过任何一部好片。我们采用先进的CDN加速与自适应码率技术，无论您使用何种网络环境，都能获得流畅不缓冲的观影体验。',
  highlights: [
    { number: '10万+', label: '影视资源' },
    { number: '99.9%', label: '播放成功率' },
    { number: '3秒', label: '平均加载速度' },
    { number: '24h', label: '不间断更新' },
  ],
};

export const commentsData = [
  {
    id: 1,
    name: '电影爱好者小李',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20photo%2C%20warm%20lighting%2C%20simple%20neutral%20background%2C%20friendly%20expression%2C%20casual%20style%2C%20professional%20headshot&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '用了七七影院两年了，真的是良心网站！更新速度超快，热门剧集当天就能看到，画质也一直稳定在1080P，关键是全程无广告，比那些充了会员还要看广告的平台强太多了。',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '追剧达人小美',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20photo%2C%20warm%20lighting%2C%20simple%20neutral%20background%2C%20gentle%20smile%2C%20modern%20casual%20style%2C%20professional%20headshot&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '终于找到一个不用下载App就能看剧的网站了！手机浏览器直接打开就能看，在公司午休追剧太方便了。资源也很全，很多其他平台要VIP的剧这里都能免费看。',
    date: '2026-07-27',
  },
  {
    id: 3,
    name: '资深影评人老王',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20photo%2C%20warm%20lighting%2C%20simple%20neutral%20background%2C%20thoughtful%20expression%2C%20professional%20headshot%2C%20glasses&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '作为看了二十多年电影的老影迷，七七影院的片库让我很惊喜。很多冷门佳作和经典老片都能找到，分类也很清晰，按年代、地区、类型搜索很方便。推荐给所有真正热爱电影的朋友。',
    date: '2026-07-26',
  },
  {
    id: 4,
    name: '学生党小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20photo%2C%20warm%20lighting%2C%20simple%20neutral%20background%2C%20bright%20smile%2C%20casual%20youth%20style%2C%20professional%20headshot&width=120&height=120&seq=avatar-04&orientation=squarish',
    rating: 4,
    content: '学生党福音！不用花钱充会员就能看所有内容，宿舍晚上几个人围在一起看电影太爽了。希望片库能再多一些最近上映的新片，那就更完美了。',
    date: '2026-07-25',
  },
  {
    id: 5,
    name: '全职妈妈阿芳',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20in%20her%2030s%20portrait%20photo%2C%20warm%20lighting%2C%20simple%20neutral%20background%2C%20warm%20smile%2C%20elegant%20casual%20style%2C%20professional%20headshot&width=120&height=120&seq=avatar-05&orientation=squarish',
    rating: 5,
    content: '带娃之余就靠七七影院放松了，剧集更新很及时，追的几部韩剧都能同步看到。播放器功能也很完善，倍速播放、跳过片头片尾都有，体验比很多大平台还好。',
    date: '2026-07-24',
  },
];

export const rankingData = [
  { rank: 1, title: '漫长的季节', category: '国产剧', heat: '9.8', tag: '口碑神作', trend: 'up' },
  { rank: 2, title: '奥本海默', category: '电影', heat: '9.5', tag: '年度巨制', trend: 'up' },
  { rank: 3, title: '庆余年 第二季', category: '国产剧', heat: '9.3', tag: '热播中', trend: 'hot' },
  { rank: 4, title: '间谍过家家', category: '动漫', heat: '9.2', tag: '人气番剧', trend: 'up' },
  { rank: 5, title: '周处除三害', category: '电影', heat: '9.0', tag: '话题之作', trend: 'new' },
  { rank: 6, title: '三体', category: '国产剧', heat: '8.9', tag: '科幻力作', trend: 'stable' },
  { rank: 7, title: '首尔之春', category: '电影', heat: '8.8', tag: '高分韩影', trend: 'up' },
];

export const indexData = [
  {
    id: 1,
    title: '2026暑期档热映大片合集',
    cover: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20movie%20poster%20collage%20with%20warm%20golden%20lighting%2C%20dramatic%20film%20scenes%2C%20theater%20atmosphere%2C%20cinematic%20composition%2C%20rich%20warm%20colors%2C%20no%20text%2C%20artistic%20movie%20aesthetic&width=800&height=500&seq=index-01&orientation=landscape',
    count: 28,
    label: '部精选',
  },
  {
    id: 2,
    title: '豆瓣9分以上经典电影推荐',
    cover: 'https://readdy.ai/api/search-image?query=Classic%20film%20collection%20aesthetic%2C%20vintage%20cinema%20feel%2C%20film%20reels%20and%20projector%2C%20warm%20nostalgic%20lighting%2C%20golden%20age%20of%20cinema%2C%20artistic%20composition%2C%20no%20text&width=800&height=500&seq=index-02&orientation=landscape',
    count: 50,
    label: '部神作',
  },
  {
    id: 3,
    title: '近期必追国产好剧大盘点',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20visual%20collage%2C%20warm%20cinematic%20lighting%2C%20modern%20Chinese%20aesthetic%2C%20dramatic%20scenes%2C%20elegant%20composition%2C%20rich%20colors%2C%20no%20text&width=800&height=500&seq=index-03&orientation=landscape',
    count: 35,
    label: '部热剧',
  },
  {
    id: 4,
    title: '韩国高分悬疑电影精选',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20cinema%20mood%2C%20dark%20dramatic%20lighting%2C%20suspenseful%20atmosphere%2C%20film%20noir%20style%2C%20cinematic%20tension%2C%20rich%20shadows%20and%20warm%20accents%2C%20no%20text&width=800&height=500&seq=index-04&orientation=landscape',
    count: 42,
    label: '部佳作',
  },
  {
    id: 5,
    title: '好莱坞科幻大片全收录',
    cover: 'https://readdy.ai/api/search-image?query=Science%20fiction%20cinema%20visual%2C%20futuristic%20atmosphere%2C%20space%20and%20technology%20themes%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20dramatic%20composition%2C%20warm%20tones%2C%20no%20text&width=800&height=500&seq=index-05&orientation=landscape',
    count: 60,
    label: '部大片',
  },
  {
    id: 6,
    title: '温馨治愈系动漫推荐',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20aesthetic%20visual%2C%20warm%20cozy%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20gentle%20color%20palette%2C%20comforting%20scenes%2C%20peaceful%20composition%2C%20no%20text&width=800&height=500&seq=index-06&orientation=landscape',
    count: 45,
    label: '部推荐',
  },
  {
    id: 7,
    title: '纪录片爱好者必看清单',
    cover: 'https://readdy.ai/api/search-image?query=Documentary%20film%20aesthetic%2C%20natural%20world%20and%20human%20stories%2C%20cinematic%20realism%2C%20warm%20natural%20lighting%2C%20authentic%20composition%2C%20rich%20earth%20tones%2C%20no%20text&width=800&height=500&seq=index-07&orientation=landscape',
    count: 38,
    label: '部精选',
  },
];

export const featuresData = [
  {
    icon: 'ri-shield-check-line',
    title: '完全免费无广告',
    desc: '所有影视资源均可免费观看，全程无贴片广告、无弹窗、无强制注册，即点即看，享受纯粹观影体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '超清画质不缓冲',
    desc: '采用多线CDN加速与自适应码率技术，智能匹配最佳清晰度。支持1080P超清画质，3秒快速加载，播放流畅不卡顿。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新同步追剧',
    desc: '专业编辑团队24小时值班，热门剧集与电影上映当天即可观看。片库覆盖全球最新资源，让您永远走在追剧第一线。',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '【2026最新】十大必看高分电影推荐',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinema%20theater%20screen%20with%20warm%20projector%20light%2C%20red%20velvet%20seats%2C%20golden%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20empty%20theater%2C%20elegant%20composition%2C%20film%20premiere%20feel&width=800&height=450&seq=media-01&orientation=landscape',
    duration: '15:28',
    views: '128.6万',
  },
  {
    id: 2,
    title: '周末影院｜一部治愈人心的法国电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=French%20cinema%20aesthetic%2C%20warm%20candlelit%20movie%20scene%2C%20intimate%20theater%20atmosphere%2C%20soft%20golden%20lighting%2C%20romantic%20film%20mood%2C%20elegant%20composition&width=800&height=450&seq=media-02&orientation=landscape',
    duration: '08:55',
    views: '96.3万',
  },
  {
    id: 3,
    title: '悬疑片爱好者必看｜烧脑反转神作盘点',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinema%20atmosphere%2C%20dramatic%20shadow%20play%2C%20film%20noir%20lighting%2C%20suspenseful%20mood%2C%20detective%20themed%20visual%2C%20warm%20accent%20lights%2C%20cinematic%20tension&width=800&height=450&seq=media-03&orientation=landscape',
    duration: '12:40',
    views: '85.7万',
  },
  {
    id: 4,
    title: '国剧崛起｜近年最佳国产电视剧巡礼',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20television%20drama%20visual%2C%20modern%20China%20aesthetic%2C%20warm%20cinematic%20lighting%2C%20dramatic%20family%20scene%2C%20elegant%20interior%2C%20rich%20cultural%20atmosphere&width=800&height=450&seq=media-04&orientation=landscape',
    duration: '18:22',
    views: '156.2万',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '暑期档爆款：《星际穿越2》震撼回归',
    desc: '诺兰导演时隔十年推出续作，再次探索时间与空间的终极奥秘。视觉特效全面升级，IMAX摄影机拍摄，带来前所未有的沉浸体验。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20space%20cinema%20scene%2C%20wormhole%20visual%2C%20dramatic%20cosmic%20lighting%2C%20astronaut%20silhouette%2C%20interstellar%20journey%2C%20cinematic%20grand%20scale%2C%20warm%20golden%20accent%20lights%2C%20no%20text&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '热映推荐',
    category: '科幻',
  },
  {
    id: 2,
    title: '高分韩剧《黑暗荣耀》第三季来袭',
    desc: '宋慧乔主演复仇爽剧第三季正式定档，编剧金银淑再献神作。第一、二季豆瓣评分均超9.0，第三季剧情全面升级，复仇大戏一触即发。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20cinematic%20visual%2C%20elegant%20dark%20atmosphere%2C%20dramatic%20lighting%2C%20suspenseful%20mood%2C%20luxury%20interior%20scene%2C%20film%20noir%20style%2C%20warm%20highlights%2C%20no%20text&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '即将上线',
    category: '韩剧',
  },
  {
    id: 3,
    title: '国漫之光《深海》续集制作中',
    desc: '导演田晓鹏继《深海》后再度出手，续集延续粒子水墨画风，讲述少女参宿的全新冒险。制作团队规模翻倍，预计2027年暑期上映。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20artistic%20visual%2C%20ink%20wash%20painting%20style%2C%20ocean%20deep%20theme%2C%20ethereal%20lighting%2C%20dreamlike%20atmosphere%2C%20flowing%20colors%2C%20warm%20and%20cool%20contrast%2C%20no%20text&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '新片速递',
    category: '动漫',
  },
  {
    id: 4,
    title: '2026奥斯卡最佳影片全收录',
    desc: '本年度奥斯卡获奖影片已全部上线，包括最佳影片、最佳导演、最佳男女主角等重磅奖项作品。高画质完整版，中英双语字幕，收藏级观影体验。',
    image: 'https://readdy.ai/api/search-image?query=Oscar%20awards%20cinema%20visual%2C%20golden%20statue%20and%20red%20carpet%2C%20elegant%20theater%20atmosphere%2C%20premium%20cinematic%20lighting%2C%20celebration%20mood%2C%20warm%20golden%20tones%2C%20no%20text&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '获奖精选',
    category: '电影',
  },
  {
    id: 5,
    title: '谍战剧天花板《风筝》未删减版',
    desc: '柳云龙执导并主演的谍战经典《风筝》未删减完整版独家上线。51集全，还原最真实的谍战风云，被誉为国产谍战剧不可逾越的巅峰之作。',
    image: 'https://readdy.ai/api/search-image?query=Spy%20thriller%20period%20drama%20visual%2C%201940s%20Shanghai%20aesthetic%2C%20vintage%20atmosphere%2C%20dramatic%20lighting%2C%20trench%20coat%20silhouette%2C%20noir%20cinematic%20style%2C%20warm%20sepia%20tones%2C%20no%20text&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '经典重现',
    category: '国产剧',
  },
  {
    id: 6,
    title: '日漫神作《进击的巨人》全系列',
    desc: '现象级日漫《进击的巨人》最终季完结篇+全四季完整上线。豆瓣9.5分，IMDb 9.1分，动画史上最具影响力的作品之一，一次看完不留遗憾。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20epic%20battle%20visual%2C%20dramatic%20cinematic%20lighting%2C%20giant%20scale%20fantasy%2C%20intense%20action%20atmosphere%2C%20warm%20and%20dark%20contrast%2C%20powerful%20composition%2C%20no%20text&width=1200&height=600&seq=carousel-06&orientation=landscape',
    tag: '全集上线',
    category: '动漫',
  },
];

export const contactInfo = {
  title: '联系我们',
  intro: '如果您有任何观影需求、资源建议或合作意向，欢迎通过以下方式与我们取得联系。七七影院团队将在24小时内回复您的消息。',
  email: 'contact@qiqicinema.com',
  qq: '1234567890',
  wechat: 'qiqicinema',
};

export const faqData = [
  {
    q: '七七影院真的完全免费吗？需要注册会员吗？',
    a: '是的，七七影院所有影视资源完全免费，无需注册、无需登录、无需充值会员。打开网站即可直接观看所有内容，我们通过技术手段维持运营，不向用户收取任何费用。',
  },
  {
    q: '为什么有些影片播放时会卡顿？',
    a: '播放卡顿通常与您的网络环境有关。我们建议：1）检查当前网络速度，1080P需要至少5Mbps带宽；2）尝试切换播放线路，我们为每部影片提供多条备用线路；3）在播放器设置中适当降低清晰度。如仍无法解决，请联系客服。',
  },
  {
    q: '支持哪些设备观看？可以投屏吗？',
    a: '七七影院采用HTML5播放器，支持所有主流设备：Windows/Mac电脑、iPhone/Android手机、iPad/Android平板。播放器内置投屏功能，支持DLNA和AirPlay协议，可一键投屏至智能电视或投影仪。',
  },
  {
    q: '影片更新频率是怎样的？新片多久能看？',
    a: '我们的编辑团队7×24小时不间断更新资源。热播剧集通常在电视台播出后2-4小时内上线；院线电影在下映后1-2周内上线高清版本；综艺节目当日更新。您可以在"最近更新"板块查看最新上线的影片。',
  },
  {
    q: '支持哪些清晰度？有4K资源吗？',
    a: '主流影片提供360P至1080P多档清晰度可选，部分热门影片提供4K超高清资源。播放器会根据您的网络状况自动推荐最佳清晰度，您也可以手动切换。建议在WiFi环境下选择高清画质以获得最佳观影体验。',
  },
  {
    q: '遇到无法播放的情况怎么办？',
    a: '如果遇到影片无法播放，请尝试以下步骤：1）刷新页面后重试；2）切换其他播放线路（播放器右下角"线路"按钮）；3）清除浏览器缓存后重新打开；4）尝试使用其他浏览器（推荐Chrome或Edge）。如问题持续，请通过联系我们页面反馈，我们会尽快修复。',
  },
];

export const cardsData = [
  {
    id: 1,
    title: '动作大片专区',
    desc: '肾上腺素飙升的视觉盛宴，好莱坞顶级动作巨制一次看过瘾。',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20cinematic%20scene%2C%20explosive%20dramatic%20lighting%2C%20car%20chase%20atmosphere%2C%20intense%20warm%20colors%2C%20thrilling%20composition%2C%20no%20text%2C%20dynamic%20visual&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '火爆推荐',
  },
  {
    id: 2,
    title: '喜剧欢乐时光',
    desc: '国内外爆笑喜剧合集，治愈不开心，笑到停不下来。',
    image: 'https://readdy.ai/api/search-image?query=Comedy%20cinema%20atmosphere%2C%20bright%20warm%20lighting%2C%20joyful%20theater%20scene%2C%20colorful%20visual%2C%20happy%20mood%2C%20lighthearted%20composition%2C%20no%20text&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '轻松一刻',
  },
  {
    id: 3,
    title: '恐怖惊悚夜',
    desc: '深夜慎入！全球高分恐怖片精选，胆大者的专属频道。',
    image: 'https://readdy.ai/api/search-image?query=Horror%20cinema%20atmosphere%2C%20dark%20dramatic%20lighting%2C%20haunting%20visual%2C%20suspenseful%20mood%2C%20shadow%20play%2C%20warm%20accent%20from%20candlelight%2C%20no%20text&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '胆量挑战',
  },
  {
    id: 4,
    title: '爱情文艺空间',
    desc: '浪漫经典与现代爱情故事，感受银幕上最动人的情感。',
    image: 'https://readdy.ai/api/search-image?query=Romance%20cinema%20visual%2C%20warm%20sunset%20lighting%2C%20intimate%20atmosphere%2C%20soft%20golden%20tones%2C%20romantic%20scene%2C%20elegant%20composition%2C%20no%20text&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '浪漫之选',
  },
  {
    id: 5,
    title: '战争史诗巨制',
    desc: '还原历史真相，震撼人心的战争电影大全。',
    image: 'https://readdy.ai/api/search-image?query=War%20epic%20cinema%20visual%2C%20dramatic%20battlefield%20lighting%2C%20historical%20atmosphere%2C%20powerful%20composition%2C%20cinematic%20grandeur%2C%20warm%20sepia%20tones%2C%20no%20text&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '历史回响',
  },
  {
    id: 6,
    title: '动画奇幻世界',
    desc: '全球动画精品汇聚，迪士尼、皮克斯、吉卜力经典全收录。',
    image: 'https://readdy.ai/api/search-image?query=Animation%20cinema%20visual%2C%20magical%20colorful%20atmosphere%2C%20fantasy%20world%2C%20warm%20glowing%20lighting%2C%20whimsical%20composition%2C%20dreamlike%20scene%2C%20no%20text&width=800&height=500&seq=card-06&orientation=landscape',
    tag: '童心未泯',
  },
  {
    id: 7,
    title: '悬疑烧脑剧场',
    desc: '反转再反转，挑战你的推理极限。悬疑佳作一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20cinema%20visual%2C%20noir%20lighting%2C%20investigation%20atmosphere%2C%20dramatic%20shadow%2C%20clue%20board%20theme%2C%20warm%20accent%20highlights%2C%20no%20text&width=800&height=500&seq=card-07&orientation=landscape',
    tag: '脑力激荡',
  },
];

export const updatesData = [
  {
    id: 1,
    date: '2026-07-31',
    title: '《庆余年3》首支预告片曝光，范闲回归引爆期待',
    category: '国产剧',
  },
  {
    id: 2,
    date: '2026-07-30',
    title: '诺兰新作《奥德赛》杀青，全明星阵容首次公开',
    category: '电影',
  },
  {
    id: 3,
    date: '2026-07-30',
    title: '豆瓣2026上半年国产剧评分榜出炉，《漫长的季节》夺冠',
    category: '榜单',
  },
  {
    id: 4,
    date: '2026-07-29',
    title: '《鱿鱼游戏》第三季定档12月，最终季剧情全面升级',
    category: '韩剧',
  },
  {
    id: 5,
    date: '2026-07-29',
    title: '吉卜力新作《苍鹭与少年》中文配音版独家上线',
    category: '动漫',
  },
  {
    id: 6,
    date: '2026-07-28',
    title: '暑期档票房突破80亿，《封神第二部》领跑大盘',
    category: '资讯',
  },
  {
    id: 7,
    date: '2026-07-27',
    title: 'BBC年度纪录片《地球脉动IV》4K完整版全网首发',
    category: '纪录片',
  },
];

export const topicsData = [
  { id: 1, name: '暑期档', count: '2.8万讨论', hot: true },
  { id: 2, name: '国产剧崛起', count: '5.6万讨论', hot: true },
  { id: 3, name: '高分电影', count: '3.2万讨论', hot: false },
  { id: 4, name: '韩剧推荐', count: '1.8万讨论', hot: true },
  { id: 5, name: '动漫新番', count: '4.1万讨论', hot: false },
  { id: 6, name: '悬疑烧脑', count: '2.3万讨论', hot: false },
  { id: 7, name: '纪录片', count: '1.2万讨论', hot: false },
  { id: 8, name: '经典重温', count: '3.5万讨论', hot: false },
  { id: 9, name: '科幻巨制', count: '2.7万讨论', hot: true },
  { id: 10, name: '4K画质', count: '1.5万讨论', hot: false },
];